export interface ReportsSortedBarChartData {
  label: string;
  total: number;
  additionalInfo: string;
}

export interface GenerateReportsRequest {
  grouping: 'Country' | 'Processor' | 'Status';
  startDate: Date;
  endDate: Date;
  filters: {
    country?: string[];
    processor?: string[];
    status?: string[];
    reasonCode?: string[];
  };
}

export interface ExecutionsOverTimeRequest {
  startDate: Date;
  endDate: Date;
  dateAggregation: string;
}

export interface StepErrorsRequest {
  startDate: Date;
  endDate: Date;
}

interface CBRReports {
  processorName: string;
  aboNumber: number;
  monthsNonCompliant: number;
  cbrDuration: number;
  startDate: string;
}

export interface CBRReportsResponse {
  total: number;
  page: { limit: number; offset: number };
  list: CBRReports[] | null;
}

export interface GenerateCBRReportsRequest {
  startDateTime: String;
  endDateTime: String;
  page: number;
  rowsPerPage: number;
}

export enum ChartOption {
  EXECUTIONS_BAR_CHART,
  EXECUTIONS_OVER_TIME,
  PROCESSOR_STEP_ERRORS,
}

export enum DateAggregation {
  DAY,
  WEEK,
  MONTH,
}

const ChartOptionLabels: Record<ChartOption, string> = {
  [ChartOption.EXECUTIONS_BAR_CHART]: 'Executions by Processor',
  [ChartOption.EXECUTIONS_OVER_TIME]: 'Executions Over Time',
  [ChartOption.PROCESSOR_STEP_ERRORS]: 'Processor Step Errors',
};

export const getChartOptionLabel = (chartOption: ChartOption): string => {
  return ChartOptionLabels[chartOption];
};
